module.exports = __webpack_public_path__ + "static/media/arts_23.a68ff4a0.jpg";